import ExcelJS from 'exceljs';
import { generateDownloadFromUrl } from '@utils/files';

export const generateExcelDownload = async (data: any[], fileName: string) => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('Sheet1');
  const [headerRow, ...tableRows] = data;

  // Add header row with formatting
  const header = worksheet.addRow(headerRow);

  header.eachCell((cell, colNumber) => {
    // eslint-disable-next-line no-param-reassign
    cell.fill = {
      fgColor: { argb: 'DCDCDC' }, // Grey color
      pattern: 'solid',
      type: 'pattern',
    };

    // eslint-disable-next-line no-param-reassign
    cell.font = {
      bold: true
    };

    // Size column to fit header text with a minimum of 20
    const headerLength = String(cell.value || '').length;
    worksheet.getColumn(colNumber).width = Math.max(20, headerLength + 8);
  });

  // Add data rows
  tableRows.forEach(row => {
    worksheet.addRow(row);
  });

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  const url = URL.createObjectURL(blob);

  generateDownloadFromUrl(url, fileName);
};
